export enum ServiceChannel {
  CREATE = 'service::create',
  EDIT = 'service::patch',
  DELETE = 'service::delete',
}
